import { connect } from 'react-redux';
import View from './NextTitleView';
import { isInSummaryEditSelector, isLastViewOnDeckSelector } from '../../AdvWorkflow/AdvWorkflowSelector';


const mapStateToProps = (state, ownProps) => ({
  nextTitle: ownProps.nextTitle,
  isInSummaryEdit: isInSummaryEditSelector(state, ownProps),
  isLastViewOnDeck: isLastViewOnDeckSelector(state, ownProps),
});

export default connect(mapStateToProps)(View);
